import React from 'react'
import { NavLink } from 'react-router-dom'
import { ReactComponent as Home } from  '../img/svg/icons/home-icon.svg'
export default function footer() {
    return (
        <div>
<div className="navbar">
<div className="footer">
    <div><NavLink to="/"><Home className="info-icon"/></NavLink></div>
    <div><p>All content copyright 2020 <a href="roaringfork.org">Roaring Fork Conservancy - </a>
            <a href="https://trout-count.web.app/">John P. Newbury Angling Arts.</a> 
            </p>
    </div>

</div>
</div>
        </div>
    )
}
